var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'img-swiper-container',
        {
            pc: _vm.isPc
        }
    ],style:([_vm.cssProperties, _vm.slideSize])},[_c('div',{ref:"swiper",staticClass:"swiper img-swiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.slideImgs),function(slide,i){return _c('div',{staticClass:"swiper-slide"},[_c('renderer',{key:slide.id,style:(_vm.parseStyle(slide.style)),attrs:{"tpl":slide}})],1)}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPreRender),expression:"!isPreRender"}],staticClass:"swiper-pagination"})])])}
var staticRenderFns = []

export { render, staticRenderFns }